import React, { useState, useEffect, useMemo } from "react";
import { BASEAPIURL, token } from "../env";

function extractMobileNumbers(phoneStr) {
  if (typeof phoneStr !== "string" || !phoneStr.trim()) return "";
  return phoneStr
    .split("\n")
    .filter((line) => !line.toLowerCase().includes("landline"))
    .filter((line) => line.trim() !== "")
    .join(", ");
}

function extractLandlines(phoneStr) {
  if (typeof phoneStr !== "string" || !phoneStr.trim()) return "";
  const lines = phoneStr
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);
  const start = lines.findIndex((line) =>
    line.toLowerCase().includes("landline")
  );
  if (start === -1) return "";
  return lines
    .slice(start + 1)
    .filter(Boolean)
    .join(", ");
}

export default function AffiliationTabs() {
  const [clubData, setClubData] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const clubsPerPage = 5;

  const [loading, setLoading] = useState(false);

  const getAffClubById = async (id) => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      tokenData: token,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${BASEAPIURL}/AffiliationClubListbyId?MainID=${id}`,
        requestOptions
      );
      const result = await response.json();

      if (result?.status == true) {
        setLoading(false);
        setClubData((pre) => {
          return pre?.map((item) => {
            if (item?.ID == id) {
              return { ...item, Image: result?.data?.Image };
            } else {
              return { ...item };
            }
          });
        });
      } else {
        setLoading(false);
        console.error("Unexpected API response:", result);
      }
    } catch (error) {
      setLoading(false);
      console.error("API error:", error);
    }
  };

  useEffect(() => {
    const fetchClubs = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        tokenData: token,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          `${BASEAPIURL}/AffiliationClubListWithOutImage`,
          requestOptions
        );
        const result = await response.json();

        if (result?.status === true && Array.isArray(result.data)) {
          setClubData(result.data);
          if (result.data.length > 0) {
            setActiveTab(result.data[0].ID.toString());
          }
        } else {
          console.error("Unexpected API response:", result);
        }
      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchClubs();
    getAffClubById(1);
  }, []);

  const cityOptions = useMemo(() => {
    return [...new Set(clubData.map((tab) => tab.City || ""))]
      .filter((city) => city.trim() !== "")
      .sort((a, b) => a.localeCompare(b));
  }, [clubData]);

  const filteredTabs = useMemo(() => {
    return clubData.filter((tab) => {
      const matchName = (tab.Name || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchCity = selectedCity ? tab.City === selectedCity : true;
      return matchName && matchCity;
    });
  }, [searchTerm, selectedCity, clubData]);

  const totalPages = Math.ceil(filteredTabs.length / clubsPerPage);
  const currentClubs = filteredTabs.slice(
    (currentPage - 1) * clubsPerPage,
    currentPage * clubsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (currentClubs.length > 0) {
      setActiveTab(currentClubs[0].ID.toString());
    }
  };

  useEffect(() => {
    if (
      currentClubs.length > 0 &&
      !currentClubs.some((tab) => tab.ID.toString() === activeTab)
    ) {
      setActiveTab(currentClubs[0].ID.toString());
    }
  }, [currentClubs, activeTab]);

  return (
    <div className="container p-2 ">
      <div className="row mb-3 g-2">
        <h1 className=" text-center" style={{ color: "#DC143C" }}>
          Affiliation Clubs
        </h1>
        <div className="col-6">
          <input
            type="text"
            className="form-control"
            placeholder="Search by club name..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-6">
          <select
            className="form-select"
            value={selectedCity}
            onChange={(e) => {
              setSelectedCity(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Cities</option>
            {cityOptions.map((city, idx) => (
              <option key={idx} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-lg-5 mb-3 mb-lg-0">
          <div
            className="Affiliation-scroll overflow-auto"
            style={{ maxHeight: "70vh" }}
          >
            <div className="nav flex-column nav-pills nav-pills-custom-Affiliation rounded-0 m-0">
              {currentClubs.map((tab) => (
                <button
                  key={tab.ID}
                  type="button"
                  className={`nav-link p-2 mb-2 mx-2 text-start ${
                    activeTab === tab.ID.toString() ? "active" : ""
                  }`}
                  onClick={() =>
                    setActiveTab(
                      tab.ID.toString(),
                      !tab?.Image && getAffClubById(tab.ID)
                    )
                  }
                  role="tab"
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      activeTab === tab.ID.toString() ? "#5A303A" : "#f8f9fa",
                    color: activeTab === tab.ID.toString() ? "#fff" : "#333",
                    border: "none",
                    borderRadius: "0.5rem",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    {/* Show image if available, otherwise fallback to first letter */}
                    {
                      // tab.Image ? (
                      //   <img
                      //     src={tab.Image}
                      //     alt={tab.Name || "Logo"}
                      //     style={{
                      //       width: "32px",
                      //       height: "32px",
                      //       objectFit: "cover",
                      //       borderRadius: "50%",
                      //     }}
                      //   />
                      // ) :
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          backgroundColor: "#ccc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          fontSize: "14px",
                          color: "#fff",
                        }}
                      >
                        {tab.Name ? tab.Name.charAt(0).toUpperCase() : "?"}
                      </div>
                    }

                    <div>
                      <div className="fw-bold small">{tab.Name || "N/A"}</div>
                      <div className="small">
                        {tab.City || "N/A"}, {tab.State || "N/A"} |{" "}
                        {tab.Address || "N/A"}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="d-flex justify-content-between mt-3 px-3">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="align-self-center small">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || totalPages === 0}
            >
              Next
            </button>
          </div>
        </div>

        <div className="col-12 col-lg-7">
          <div className="tab-content">
            {filteredTabs.map((tab) => (
              <div
                key={tab.ID}
                className={`tab-pane fade p-0 ${
                  activeTab === tab.ID.toString() ? "show active" : ""
                }`}
              >
                <div className="row justify-content-center">
                  <div className="col-8">
                    <div className=" border-0 rounded-4 shadow-sm h-100 hover-shadow">
                      {loading && !tab.Image && (
                        <span
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <span className="loader"></span>
                        </span>
                      )}
                      {tab.Image && tab.Image.trim() !== "" && (
                        <img
                          src={tab.Image}
                          className="card-img-top rounded-top-4"
                          alt={tab.Name}
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "contain",
                          }}
                          loading="lazy"
                        />
                      )}
                      <div className="px-4 py-3">
                        {tab.Name && (
                          <>
                            <h5 className="card-title text-danger fw-bold">
                              {tab.Name}
                            </h5>
                          </>
                        )}

                        {tab.Mobile && (
                          <>
                            <p className="mb-1 small text-secondary fw-semibold">
                              Mobile No.
                            </p>
                            <p className="mb-2">{tab.Mobile}</p>
                          </>
                        )}

                        {tab.Phone && (
                          <>
                            <p className="mb-1 small text-secondary fw-semibold">
                              Landline
                            </p>
                            <p className="mb-2">{tab.Phone}</p>
                          </>
                        )}

                        {tab.Address && (
                          <>
                            <p className="mb-1 small text-secondary fw-semibold">
                              Address
                            </p>
                            <p className="mb-2">{tab.Address}</p>
                          </>
                        )}

                        {tab.City && (
                          <>
                            <p className="mb-1 small text-secondary fw-semibold">
                              City
                            </p>
                            <p className="mb-2">{tab.City}</p>
                          </>
                        )}

                        {tab.Website && (
                          <>
                            <p className="mb-1 small text-secondary fw-semibold">
                              Website
                            </p>
                            <p className="mb-0">
                              <a
                                href={tab.Website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-primary text-decoration-none"
                              >
                                {tab.Website}
                              </a>
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>
        {`
                .Affiliation-scroll {
                    overflow-y: auto;
                    max-height: 75vh;
                }

                .nav-pills-custom-Affiliation .nav-link {
                    font-size: 0.95rem;
                    font-weight: 500;
                    color: #333;
                    background-color: #f8f9fa;
                    border-radius: 0.5rem;
                    transition: background-color 0.2s;
                }

                .nav-pills-custom-Affiliation .nav-link.active {
                    background-color: #5B333C;
                    color: #fff;
                }

                @media (max-width: 576px) {
                    .card-title {
                        font-size: 1rem;
                    }
                    .card-body {
                        padding: 1rem;
                    }
                    .nav-pills-custom-Affiliation .nav-link {
                        font-size: 0.85rem;
                    }
                    .Affiliation-scroll {
                        max-height: 50vh;
                    }
                }

                @media (min-width: 577px) and (max-width: 768px) {
                    .Affiliation-scroll {
                        max-height: 60vh;
                    }
                }

                .hover-shadow:hover {
                    box-shadow: 0 0 15px rgba(0,0,0,0.15) !important;
                }

                .card-img-top {
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                }
                `}
      </style>
    </div>
  );
}
